/**
 * User: Shad
 * Date: 9/27/13
 */
"use strict";

var PaymentMethod = require('bunsen/models/ecomm/PaymentMethodModel');
var DirectPayment = module.exports = PaymentMethod.extend();
var SoaModel = require('bunsen/models/SoaModel');
var _ = require('underscore');

_.extend(DirectPayment.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Direct Payment';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'DIRECT_PAYMENT'
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/payment-methods/DirectPayment.js
// module id = 188
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55